<template>
  <NotificationTemplate
    :notification="notification"
    class="notification-reaction"
  >
    <template #pic>
      <Avatar
        :src="notification.initiatorAvatarSrc || null"
        :gap="notification.getInitials()"
      />
    </template>
    <template #title>
      <BaseSubHeading
        size="large"
        color="monochrome-06"
        darkColor="monochrome-03"
        weight="400"
      >
        <a
          class="link is-large"
          target="_blank"
          :href="notification.itemHref"
        >
          {{ notification.itemLabel }}
        </a>
      </BaseSubHeading>
      <BaseSubHeading
        size="large"
        color="monochrome-06"
        darkColor="monochrome-03"
        weight="400"
      >
        <span class="notification__update-item__initiator">{{
          notification.initiatorFullName
        }}</span>
        reacted to your comment
      </BaseSubHeading>
    </template>
    <template #content>
      <div class="notification-reaction__content">
        <div class="notification-reaction__content__left">
          <BaseSubHeading
            size="medium"
            color="monochrome-06"
            darkColor="monochrome-03"
            weight="400"
            className="notification__update-item__description"
          >
            <ReferencedText
              :resetStyle="true"
              :html="notification.message"
            />
          </BaseSubHeading>

          <NotificationAttachmentFiles
            v-if="notification.attachments?.length"
            :attachments="notification.attachments"
            :itemUrl="notification.resourceUrl"
            :attachmentsCount="notification.attachmentsCount"
          />
        </div>
        <div
          v-if="notification.reactionType"
          class="notification-reaction__content__right"
        >
          <img
            :src="emojiData[notification.reactionType].src"
            :alt="emojiData[notification.reactionType].alt"
            class="notification-reaction__emoji"
          />
        </div>
      </div>
    </template>
  </NotificationTemplate>
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component"
import { Prop } from "vue-property-decorator"

import Avatar from "@/components/Avatar/index.vue"
import NotificationAttachmentFiles from "@/components/Notification/components/NottificationAttacmentFiles.vue"
import NotificationTemplate from "@/components/Notification/NotificationTemplate.vue"

import { EmojiData } from "@/models"
import { NotificationComment } from "@/models/Notification/NotificationComment"

import { ReferencedText } from "../../Reference"

@Options({
  name: "REACTION_ADDED_TO_COMMENT",
  components: {
    NotificationAttachmentFiles,
    NotificationTemplate,
    Avatar,
    ReferencedText
  }
})
export default class REACTION_ADDED_TO_COMMENT extends Vue {
  @Prop() readonly notification: NotificationComment

  get emojiData() {
    return EmojiData
  }
}
</script>
